<template>
<div>
  <div class="wistia_embed wistia_async_qztw06ghy1">
    &nbsp;
  </div>

  <div
    id="vid-embeds-3-1"
    class="tbk-vid-embed mobile-white-background"
  >
    <div id="vid-question">
      What percentage of Americans over the age of 55 have at least one chronic condition?
    </div>

    <a
      class="embedded_video"
      href="#wistia_369i80dpzl?videoFoam=true"
    >
      <button id="thirty-five-pct">35%</button>
    </a>

    <a
      class="embedded_video"
      href="#wistia_vpl2g0gwqv?videoFoam=true"
    >
      <button id="sixty-five-pct">65%</button>
    </a>

    <a
      class="embedded_video"
      href="#wistia_6gcx4i0gd6?videoFoam=true"
    >
      <button id="eighty-five-pct">85%</button>
    </a>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    _wq.push({
      qzt: this.showSelect,
      369: this.showSelect,
      vpl: this.showSelect,
      '6gc': this.showSelect
    })

    if (this.tbk.isMobile()) {
      _wq.push({
        369: this.tbk.autoPlay,
        vpl: this.tbk.autoPlay,
        '6gc': this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect(video) {
      const that = this
      video.bind('end', function() {
        if (this.hashedId() !== 'qztw06ghy1') {
          $('#vid-question').text('Try a different response.')
        }

        $('.tbk-vid-embed').show()
        that.tbk.hideMobileControls()
      })
    }
  }
}
</script>

<style scoped lang="sass">
#vid-embeds-3-1
  display: none
  font-family: "azo-sans-web", sans-serif
.tbk-vid-embed
  #vid-question
    position: relative
    top: calc(100% * (100 / 360))
    color: rgb(0, 0, 0)
    font-size: 30px
    font-weight: normal
    font-style: normal
    padding: 9.4321px
    text-align: center
  button
    background: #e74c3c
    border: none
    box-shadow: 0 .4em 0 0 #f9d2ce
    cursor: pointer
    display: table
    line-height: 1em
    padding: .875em 2em
    font-size: 16px
    border-radius: .6em
    -moz-border-radius: .6em
    -webkit-border-radius: .6em
    &:hover
      opacity: 0.85
a
  &:link
    &.embedded_video
      color: #fff !important
      font-size: 16px
      font-weight: 600
      font-style: normal
      line-height: 1.4em
      text-decoration: none
#thirty-five-pct
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (65 / 640))
  width: calc(100% * (150 / 640))
  height: calc(100% * (45 / 360))
#sixty-five-pct
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (250 / 640))
  width: calc(100% * (150 / 640))
  height: calc(100% * (45 / 360))
#eighty-five-pct
  position: absolute
  top: calc(100% * (255 / 360))
  left: calc(100% * (430 / 640))
  width: calc(100% * (150 / 640))
  height: calc(100% * (45 / 360))

@media (max-width: 450px)
  .tbk-vid-embed #vid-question
    top: calc(100% * (50 / 360))
    font-size: 18px
  .tbk-vid-embed button
    font-size: 12px
    padding-top: 6px
    padding-bottom: 6px
</style>
